import { newAxiosIns } from '@/libs/axios'

const URL = '/komchat-api/api/v1/broadcast'

export function apiGetBroadcast(search, cursor, limit, broadcast_type, broadcast_status, start_date, end_date) {
  const params = {
    search,
    cursor,
    limit,
    broadcast_type,
    broadcast_status,
    start_date,
    end_date,
  }
  return newAxiosIns.get(`${URL}`, { params })
}

export function apiSendBroadcast({ param }) {
  return newAxiosIns.post(`${URL}/send-broadcast`, param)
}

export function apiSendPreview({ param }) {
  return newAxiosIns.post(`${URL}/send-preview`, param)
}

export function apiActionBroadcast({ param }) {
  if (param.action === 'delete') {
    return newAxiosIns.delete(`${URL}/${param.id}/delete`)
  }
  return newAxiosIns.post(`${URL}/${param.id}/${param.action}`)
}

export function apiSaveTempImage({ formData }) {
  return newAxiosIns.post('/komchat-api/api/v1/media/upload/img-temp', formData)
}

export function apiSpintax({ param }) {
  return newAxiosIns.post('/komchat-api/api/v1/ai/generate-spintax-text', param)
}

// for brands

export function apiListBroadcastForBrand(limit, offset, keyword) {
  const params = {
    limit,
    offset,
    keyword,
  }
  return newAxiosIns.get('/komchat-api/api/v1/kfb/broadcasts', { params })
}

export function apiRequestBroadcastForBrand({ params }) {
  return newAxiosIns.post('/komchat-api/api/v1/kfb/request-broadcast', params)
}

export function apiSaveTempImageForBrand({ formData }) {
  return newAxiosIns.post('/komchat-api/api/v1/kfb/media/upload/img-temp', formData)
}

export function apiSendBroadcastForBrand(id) {
  const params = {
    id,
  }
  return newAxiosIns.post('/komchat-api/api/v1/kfb/send-broadcast', params)
}

export function apiHistoryBroadcastForBrand(limit, offset) {
  const params = {
    limit,
    offset,
  }
  return newAxiosIns.get('/komchat-api/api/v1/kfb/history-broadcast', { params })
}

export function apiInfoBroadcastForBrand(id) {
  let url = '/komchat-api/api/v1/kfb/info-broadcast'
  if (id) {
    url += `?broadcast_id=${id}`
  }
  return newAxiosIns.get(url)
}

export function apiGetListTemplateForBrands(limit, offset, keyword) {
  const params = {
    limit,
    offset,
    keyword,
  }
  return newAxiosIns.get('/komchat-api/api/v1/kfb/templates', { params })
}

export function apiGetDetailBroadcastForBrands(id, limit, offset) {
  const params = {
    limit,
    offset,
  }
  return newAxiosIns.get(`/komchat-api/api/v1/kfb/history-broadcast/${id}`, { params })
}

export function apiSendBroadcastForBrands(template_id, group_contact_ids) {
  const params = {
    template_id,
    group_contact_ids,
  }
  return newAxiosIns.post('/komchat-api/api/v2/kfb/send-broadcast', params)
}

export function apiGetBroadcastLiteInfo(broadcast_type, broadcast_status, start_date, end_date) {
  const params = {
    broadcast_type,
    broadcast_status,
    start_date,
    end_date,
  }
  return newAxiosIns.get(`${URL}/info`, { params })
}

export function apiGetDetailBroadcastHistoryLite(id, cursor, limit) {
  const params = {
    cursor,
    limit,
  }
  return newAxiosIns.get(`${URL}/${id}/history`, { params })
}
export function apiGetDetailBroadcastInfoLite(id) {
  return newAxiosIns.get(`${URL}/${id}/info`)
}

export function apiGetListFailedContact(id, cursor, limit) {
  const params = {
    cursor,
    limit,
  }
  return newAxiosIns.get(`${URL}/${id}/failed_list`, { params })
}

export function apiResendBroadcast(group_broadcast_id, group_contact_ids, resend_mode, new_title, schedule) {
  const params = {
    group_contact_ids,
    resend_mode,
    group_broadcast_id,
    new_title,
    schedule,
  }
  return newAxiosIns.post('/komchat-api/api/v2/broadcast/resend-broadcast', params)
}
